import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import {
  ArrowLeft,
  Plus,
  Briefcase,
  Building,
  MapPin,
  DollarSign,
  Clock,
  Eye,
  LogOut,
  Users,
  Calendar,
  UserPlus,
  Shield,
  Edit,
  Save,
  X,
  Search,
} from "lucide-react";
// import Link from "next/link";
// import { useRouter } from "next/navigation";
import { toast } from "sonner";
// import {
//   isAdminAuthenticated,
//   logoutAdmin,
//   getAdminData,
// } from "../../lib/auth";
// import { logoutURL } from "../../lib/AppConstant";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import RichTextEditor from "../Questions/RichTextEditor";
import { JobPostForm } from "./JobPost";
// import { JobApplications } from "./job-applications";
import axios from "axios";
import { JobApplications } from "./JobApplication";

const api = axios.create({
  baseURL: 'https://localhost:7022',
  headers: {
    accept: "*/*",
    // Authorization: `Bearer ${token}`,
  },
});

interface Job {
  id: string;
  jobTitle: string;
  companyName: string;
  location: string;
  employerType: string;
  description: string;
  expirationDate: string;
  contactEmail: string;
  roleType: number;
  workplaceType: number;
  preferredCourses: [];
  preferredSkills: [];
  createdOn: string;
  updatedon: string;
}


// interface Job {
//   _id: string;
//   title: string;
//   company: string;
//   location: string;
//   type: string;
//   description: string;
//   requirements: string;
//   salary: {
//     min: number;
//     max: number;
//   };
//   imageUrl?: string;
//   isActive: boolean;
//   createdAt: string;
//   updatedAt?: string;
// }

interface Application {
  id: string;
  studentId: string;
  resume: string;
  coverLetter: string;
  videoPitch: string;
  status: number; // 1=Applied, 2=Shortlisted, 3=Interviewed, 4=Offered
  jobId: string;
  jobResponse: {
    responseMessage: string;
    offerLetter: string;
    expiryDate: string;
    offerStatus: number; // 1=Pending, 2=Accepted, 3=Rejected, 4=Question
    createdOn: string;
  };
  createdOn: string;
  updatedon: string;
}

interface Admin {
  _id: string;
  name: string;
  email: string;
  role: string;
  isActive: boolean;
  createdAt: string;
  lastLogin?: string;
}

export default function JobBoardDashboard() {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [applications, setApplications] = useState<Application[]>([]);
  const [admins, setAdmins] = useState<Admin[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [showAdminForm, setShowAdminForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);
  const [jobApplications, setJobApplications] = useState<Application[]>([]);
  const [currentAdmin, setCurrentAdmin] = useState<any>(null);

  const [editingJob, setEditingJob] = useState<Job | null>(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editFormData, setEditFormData] = useState({
    title: "",
    company: "",
    location: "",
    roleType: "FullTime",
    workplaceType: "Onsite",
    description: "",
    employerType: "",
    expirationDate: "",
    contactEmail: "",
    preferredSkills: [],
    preferredCourses: [],
  });
  const [adminFormData, setAdminFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "admin",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [jobType, setJobType] = useState("all");
  const [jobToToggle, setJobToToggle] = useState<{
    id: string;
    isActive: boolean;
    title: string;
  } | null>(null);

  // const router = useRouter();

  // useEffect(() => {
  //   if (!isAdminAuthenticated()) {
  //     router.push("/admin/login");
  //     return;
  //   }
  //   // const adminData = getAdminData();
  //   // setCurrentAdmin(adminData);
  //   fetchJobs();
  //   fetchAdmins();
  // }, [router]);

  // Fetch applications after jobs are loaded
  useEffect(() => {
    if (jobs.length > 0) {
      fetchApplications();
    }
  }, [jobs]);

  const fetchJobs = async () => {
    try {
      const params: any = {};
      if (searchTerm) params.search = searchTerm;
      if (jobType && jobType !== "all") params.type = jobType;

      const response = await api.get("/JobBoard/job-opportunity", { params });
      const data = response.data;
      const jobs: Job[] = (data.resultObject || []).map((item: any) => ({
        ...item,
        id: item.id || item._id,
      }));
      setJobs(jobs);
    } catch (error) {
      console.error("Error fetching jobs:", error);
      // If axios error, print response body/status for easier debugging
      if (axios.isAxiosError(error)) {
        console.error("Axios error response:", error.response?.status, error.response?.data);
      }
      toast.error("Failed to fetch jobs");
    } finally {
      setLoading(false);
    }
  };

  // Fetch jobs on mount so the page loads data automatically.
  useEffect(() => {
    fetchJobs();
    fetchAdmins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchApplications = async () => {
    try {
      // Fetch applications for all jobs
      const allApplications: Application[] = [];
      
      for (const job of jobs) {
        try {
          const response = await api.get(`/JobBoard/job-application/job/${job.id}`);
          const data = response.data;
          if (data.resultObject && Array.isArray(data.resultObject)) {
            allApplications.push(...data.resultObject);
          }
        } catch (error) {
          console.error(`Error fetching applications for job ${job.id}:`, error);
        }
      }
      
      setApplications(allApplications);
    } catch (error) {
      console.error("Error fetching applications:", error);
      toast.error("Failed to fetch applications");
    }
  };

  const fetchAdmins = async () => {
    // try {
    //   const response = await fetch("/api/admins");
    //   const data = await response.json();
    //   setAdmins(data.admins || []);
    // } catch (error) {
    //   console.error("Error fetching admins:", error);
    //   toast.error("Failed to fetch admins");
    // }
    console.log("Fetch admins is currently disabled");
  };

  const handleAdminSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/admins", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(adminFormData),
      });

      if (response.ok) {
        toast.success("Admin created successfully!");
        setAdminFormData({
          name: "",
          email: "",
          password: "",
          role: "admin",
        });
        setShowAdminForm(false);
        fetchAdmins();
      } else {
        const error = await response.json();
        toast.error(error.error || "Failed to create admin");
      }
    } catch (error) {
      console.error("Error creating admin:", error);
      toast.error("Failed to create admin");
    }
  };

  // const handleLogout = () => {
  //   logoutAdmin();
  //   toast.success("Logged out successfully");
  //   // Redirect to Auth0 logout URL to clear Auth0 session
  //   window.location.href = logoutURL;
  // };

  const viewJobDetails = (job: Job) => {
    setSelectedJob(job);
    const jobApps = applications.filter(
      (app) => app.jobId === job.id
    );
    setJobApplications(jobApps);
  };

  const startEditJob = (job: Job) => {
    setEditingJob(job);
    // roleType: 1 = FullTime, 2 = PartTime, 3 = Internship (map 4 hoặc khác về 3)
    let typeValue = "1";
    if (job.roleType === 2) typeValue = "2";
    else if (job.roleType === 3) typeValue = "3";
    setEditFormData({
      title: job.jobTitle,
      company: job.companyName,
      location: job.location,
      roleType: typeValue,
      workplaceType: typeValue,
      description: job.description,
      employerType: job.employerType || "",
      expirationDate: job.expirationDate ? job.expirationDate.slice(0, 10) : "",
      contactEmail: job.contactEmail || "",
      preferredCourses: job.preferredCourses || [],
      preferredSkills: job.preferredSkills || [],
    });
    setShowEditForm(true);
  };

  const handleEditSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editingJob) return;

    // Merge old job data with new form data
    const jobData = {
      ...editingJob,
      jobTitle: editFormData.title || editingJob.jobTitle,
      companyName: editFormData.company || editingJob.companyName,
      location: editFormData.location || editingJob.location,
      roleType: Number(editFormData.roleType) || 1,
      workplaceType: Number(editFormData.workplaceType) || 1,
      description: editFormData.description || editingJob.description,
      employerType: editFormData.employerType || editingJob.employerType,
      expirationDate: editFormData.expirationDate || editingJob.expirationDate,
      contactEmail: editFormData.contactEmail || editingJob.contactEmail,
      preferredCourses:
        editFormData.preferredCourses || editingJob.preferredCourses,
      preferredSkills:
        editFormData.preferredSkills || editingJob.preferredSkills,
    };

    try {
      const response = await api.put(
        `/JobBoard/job-opportunity/${editingJob.id}`,
        jobData
      );

      if (response) {
        toast.success("Job updated successfully!");
        setShowEditForm(false);
        setEditingJob(null);
        fetchJobs(); // Refresh the jobs list
      } else {
        toast.error("Failed to update job");
      }
    } catch (error) {
      console.error("Error updating job:", error);
      toast.error("Failed to update job");
    }
  };

  const cancelEdit = () => {
    setShowEditForm(false);
    setEditingJob(null);
    setEditFormData({
      title: "",
      company: "",
      location: "",
      roleType: "FullTime",
      workplaceType: "Onsite",
      description: "",
      employerType: "",
      expirationDate: "",
      contactEmail: "",
      preferredCourses: [],
      preferredSkills: [],
      // requirements: "",
      // salaryMin: "",
      // salaryMax: "",
      // imageUrl: "",
      // isActive: true,
    });
  };

  const getTypeColor = (roleType: number) => {
    switch (roleType) {
      case 1:
        return "bg-green-100 text-green-800";
      case 2:
        return "bg-blue-100 text-blue-800";
      case 3:
        return "bg-purple-100 text-purple-800";
      case 4:
        return "bg-orange-100 text-orange-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const mapRoleTypeToText = (roleType: number) => {
    switch (roleType) {
      case 1:
        return "Full Time";
      case 2:
        return "Part Time";
      case 3:
        return "Internship";
    }
  };

  const getStatusColor = (status: number) => {
    switch (status) {
      case 1: // Applied
        return "bg-blue-100 text-blue-800";
      case 2: // Shortlisted
        return "bg-yellow-100 text-yellow-800";
      case 3: // Interviewed
        return "bg-purple-100 text-purple-800";
      case 4: // Offered
        return "bg-green-100 text-green-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const getApplicationStatusText = (status: number) => {
    switch (status) {
      case 1:
        return "Applied";
      case 2:
        return "Shortlisted";
      case 3:
        return "Interviewed";
      case 4:
        return "Offered";
      default:
        return "Unknown";
    }
  };

  const handleJobStatusChange = async (jobId: string, isActive: boolean) => {
    try {
      const response = await fetch("/api/jobs", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: jobId, isActive }),
      });

      if (response.ok) {
        setJobs(
          jobs.map((job) => (job.id === jobId ? { ...job, isActive } : job))
        );
        toast.success(
          `Job ${isActive ? "activated" : "deactivated"} successfully`
        );
      } else {
        toast.error("Failed to update job status");
      }
    } catch (error) {
      console.error("Error updating job status:", error);
      toast.error("Failed to update job status");
    } finally {
      setJobToToggle(null);
    }
  };

  const handleSearch = () => {
    fetchJobs();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {/* <Button variant="ghost" size="sm" asChild>
                <Link href="/">
                  <ArrowLeft className="h-4 w-4 mr-2" />
                  Back to Jobs
                </Link>
              </Button> */}
              <div className="flex items-center space-x-2">
                <Briefcase className="h-6 w-6 text-blue-600" />
                <h1 className="text-xl font-bold text-slate-800">
                  Admin Panel
                </h1>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              {/* <Button variant="outline" onClick={handleLogout}>
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </Button> */}
            </div>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8">
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <Card className="border-0 shadow-lg">
            <CardContent className="p-6">
              <div className="flex items-center space-x-4">
                <div className="p-3 bg-blue-100 rounded-full">
                  <Briefcase className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-800">
                    {jobs.length}
                  </p>
                  <p className="text-sm text-slate-600">Active Jobs</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg">
            <CardContent className="p-6">
              <div className="flex items-center space-x-4">
                <div className="p-3 bg-green-100 rounded-full">
                  <Users className="h-6 w-6 text-green-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-800">
                    {applications.length}
                  </p>
                  <p className="text-sm text-slate-600">Total Applications</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg">
            <CardContent className="p-6">
              <div className="flex items-center space-x-4">
                <div className="p-3 bg-purple-100 rounded-full">
                  <Calendar className="h-6 w-6 text-purple-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-800">
                    {
                      applications.filter((app) => app.status === 1)
                        .length
                    }
                  </p>
                  <p className="text-sm text-slate-600">Pending Reviews</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg">
            <CardContent className="p-6">
              <div className="flex items-center space-x-4">
                <div className="p-3 bg-orange-100 rounded-full">
                  <Shield className="h-6 w-6 text-orange-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-slate-800">
                    {admins.length}
                  </p>
                  <p className="text-sm text-slate-600">Total Admins</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Main Content with Tabs */}
        <Tabs defaultValue="jobs" className="w-full">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="jobs">Jobs Management</TabsTrigger>
            <TabsTrigger value="applications">Applications</TabsTrigger>
            <TabsTrigger value="admins">Admin Management</TabsTrigger>
          </TabsList>

          {/* Jobs Tab */}
          <TabsContent value="jobs" className="space-y-4">
            <div className="flex items-center justify-between">
              <h2 className="text-2xl font-bold text-slate-800">
                Job Postings ({jobs.length})
              </h2>
              <Button
                onClick={() => setShowForm(!showForm)}
                className="bg-blue-600 hover:bg-blue-700"
              >
                <Plus className="h-4 w-4 mr-2" />
                {showForm ? "Cancel" : "Add Job"}
              </Button>
            </div>

            {/* Search and Filter Section */}
            <div className="flex gap-4 mb-6">
              <div className="flex-1">
                <div className="relative">
                  <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                  <Input
                    placeholder="Search jobs..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10"
                  />
                </div>
              </div>
              <Select value={jobType} onValueChange={setJobType}>
                <SelectTrigger className="w-[180px]">
                  <SelectValue placeholder="Filter by type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Types</SelectItem>
                  <SelectItem value="full-time">Full Time</SelectItem>
                  <SelectItem value="part-time">Part Time</SelectItem>
                  <SelectItem value="contract">Contract</SelectItem>
                  <SelectItem value="internship">Internship</SelectItem>
                </SelectContent>
              </Select>
              <Button onClick={handleSearch}>Search</Button>
            </div>

            {showForm && <JobPostForm />}

            {/* Edit Job Form Dialog */}
            {showEditForm && (
              <Dialog open={showEditForm} onOpenChange={setShowEditForm}>
                <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
                  <DialogHeader>
                    <DialogTitle className="flex items-center space-x-2">
                      <Edit className="h-5 w-5" />
                      <span>Edit Job: {editingJob?.jobTitle}</span>
                    </DialogTitle>
                    <DialogDescription>
                      Update the job details below
                    </DialogDescription>
                  </DialogHeader>

                  <form onSubmit={handleEditSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="editTitle">Job Title</Label>
                        <Input
                          id="editTitle"
                          value={editFormData.title}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              title: e.target.value,
                            })
                          }
                          placeholder="e.g. Senior Software Engineer"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="editCompany">Company</Label>
                        <Input
                          id="editCompany"
                          value={editFormData.company}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              company: e.target.value,
                            })
                          }
                          placeholder="e.g. Tech Corp"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="editWorkplaceType">
                          Workplace Type
                        </Label>
                        <Select
                          value={editFormData.workplaceType}
                          onValueChange={(value) =>
                            setEditFormData({
                              ...editFormData,
                              workplaceType: value,
                            })
                          }
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Select workplace type" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="1">Onsite</SelectItem>
                            <SelectItem value="2">Remote</SelectItem>
                            <SelectItem value="3">Hybrid</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="editLocation">Location</Label>
                        <Input
                          id="editLocation"
                          value={editFormData.location}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              location: e.target.value,
                            })
                          }
                          placeholder="e.g. San Francisco, CA"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="editType">Job Type</Label>
                        <Select
                          value={editFormData.roleType}
                          onValueChange={(value) =>
                            setEditFormData({
                              ...editFormData,
                              roleType: value,
                            })
                          }
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Select job type" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="1">Full Time</SelectItem>
                            <SelectItem value="2">Part Time</SelectItem>
                            <SelectItem value="3">Internship</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="editContactEmail">Contact Email</Label>
                        <Input
                          id="editContactEmail"
                          type="email"
                          value={editFormData.contactEmail}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              contactEmail: e.target.value,
                            })
                          }
                          placeholder="e.g. hr@techcorp.com"
                          required
                        />
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="editExpirationDate">
                          Expiration Date
                        </Label>
                        <Input
                          id="editExpirationDate"
                          type="date"
                          value={editFormData.expirationDate}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              expirationDate: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="editEmployerType">Employer Type</Label>
                        <Input
                          id="editEmployerType"
                          value={editFormData.employerType}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              employerType: e.target.value,
                            })
                          }
                          placeholder="e.g. Startup, Corporate"
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="editPreferredCourses">
                          Preferred Courses (comma separated)
                        </Label>
                        <Input
                          id="editPreferredCourses"
                          value={editFormData.preferredCourses.join(", ")}
                          // onChange={(e) =>
                          //   setEditFormData({
                          //     ...editFormData,
                          //     preferredCourses: e.target.value
                          //       .split(",")
                          //       .map((course) => course.trim()),
                          //   })
                          // }
                          placeholder="e.g. CS101, CS102"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="editPreferredSkills">
                          Preferred Skills (comma separated)
                        </Label>
                        <Input
                          id="editPreferredSkills"
                          value={editFormData.preferredSkills.join(", ")}
                          // onChange={(e) =>
                          //   setEditFormData({
                          //     ...editFormData,
                          //     preferredSkills: e.target.value
                          //       .split(",")
                          //       .map((skill) => skill.trim()),
                          //   })
                          // }
                          placeholder="e.g. JavaScript, Python"
                        />
                      </div>
                    </div>

                    {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="editSalaryMin">Minimum Salary</Label>
                        <Input
                          id="editSalaryMin"
                          type="number"
                          value={editFormData.salaryMin}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              salaryMin: e.target.value,
                            })
                          }
                          placeholder="50000"
                          required
                        />
                      </div> */}
                    {/* <div className="space-y-2">
                        <Label htmlFor="editSalaryMax">Maximum Salary</Label>
                        <Input
                          id="editSalaryMax"
                          type="number"
                          value={editFormData.salaryMax}
                          onChange={(e) =>
                            setEditFormData({
                              ...editFormData,
                              salaryMax: e.target.value,
                            })
                          }
                          placeholder="100000"
                          required
                        />
                      </div>
                    </div> */}

                    <div className="space-y-2">
                      <Label htmlFor="description">Description</Label>
                      <RichTextEditor
                        value={editFormData.description}
                        onChange={(value: any) =>
                          setEditFormData({
                            ...editFormData,
                            description: value,
                          })
                        }
                      />
                    </div>

                    {/* <div className="space-y-2">
                      <Label htmlFor="requirements">Requirements</Label>
                      <RichTextEditor
                        value={editFormData.requirements}
                        onChange={(value) =>
                          setEditFormData({
                            ...editFormData,
                            requirements: value,
                          })
                        }
                      />
                    </div>

                    <div className="space-y-2">
                      <Label htmlFor="editImageUrl">
                        Job Image URL (Optional)
                      </Label>
                      <Input
                        id="editImageUrl"
                        type="url"
                        value={editFormData.imageUrl}
                        onChange={(e) =>
                          setEditFormData({
                            ...editFormData,
                            imageUrl: e.target.value,
                          })
                        }
                        placeholder="https://images.unsplash.com/photo-... or https://pixabay.com/..."
                      />
                      <p className="text-xs text-slate-500">
                        Add an image URL from Unsplash, Pixabay, or any other
                        image hosting service
                      </p>
                    </div> */}

                    <div className="flex items-center justify-between pt-4">
                      <Button
                        type="button"
                        variant="outline"
                        onClick={cancelEdit}
                      >
                        <X className="h-4 w-4 mr-2" />
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="bg-blue-600 hover:bg-blue-700"
                      >
                        <Save className="h-4 w-4 mr-2" />
                        Update Job
                      </Button>
                    </div>
                  </form>
                </DialogContent>
              </Dialog>
            )}

            {loading ? (
              <div className="grid grid-cols-1 gap-4">
                {[...Array(3)].map((_, i) => (
                  <Card key={i} className="animate-pulse">
                    <CardHeader>
                      <div className="h-5 bg-slate-200 rounded w-3/4 mb-2"></div>
                      <div className="h-4 bg-slate-200 rounded w-1/2"></div>
                    </CardHeader>
                  </Card>
                ))}
              </div>
            ) : jobs.length === 0 ? (
              <Card className="text-center py-12">
                <CardContent>
                  <Briefcase className="h-16 w-16 text-slate-400 mx-auto mb-4" />
                  <p className="text-slate-600 text-lg mb-2">
                    No jobs posted yet
                  </p>
                  <p className="text-slate-500 mb-6">
                    Create your first job posting to get started
                  </p>
                  <Button onClick={() => setShowForm(true)}>
                    <Plus className="h-4 w-4 mr-2" />
                    Post Your First Job
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <div className="space-y-4">
                {jobs.map((job) => (
                  <Card key={job.id} className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <div className="flex items-center space-x-4">
                          <div>
                            <h3 className="font-semibold text-lg">
                              {job.jobTitle}
                            </h3>
                            <div className="flex items-center space-x-4 text-sm text-gray-500">
                              <span className="flex items-center">
                                <Building className="h-4 w-4 mr-1" />
                                {job.companyName}
                              </span>
                              <span className="flex items-center">
                                <MapPin className="h-4 w-4 mr-1" />
                                {job.location}
                              </span>
                              <Badge
                                variant="secondary"
                                className={getTypeColor(job.roleType)}
                              >
                                {mapRoleTypeToText(job.roleType)}
                              </Badge>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-4">
                        {/* <div className="flex items-center space-x-2">
                          <Switch
                            checked={job.isActive}
                            onCheckedChange={(checked) =>
                              setJobToToggle({
                                id: job._id,
                                isActive: checked,
                                title: job.title,
                              })
                            }
                          />
                          <span className="text-sm text-gray-500">
                            {job.isActive ? "Active" : "Hidden"}
                          </span>
                        </div> */}
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => viewJobDetails(job)}
                        >
                          <Eye className="h-4 w-4 mr-2" />
                          View
                        </Button>
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => startEditJob(job)}
                        >
                          <Edit className="h-4 w-4 mr-2" />
                          Edit
                        </Button>
                      </div>
                    </div>
                  </Card>
                ))}
              </div>
            )}
          </TabsContent>

          {/* Applications Tab */}
          <TabsContent value="applications" className="space-y-4">
            <JobApplications applications={applications} />
          </TabsContent>

          {/* Admin Management Tab */}
          <TabsContent value="admins" className="space-y-4">
            <div className="flex items-center justify-between">
              <h2 className="text-2xl font-bold text-slate-800">
                Admin Management ({admins.length})
              </h2>
              {currentAdmin?.role === "super-admin" && (
                <Button
                  onClick={() => setShowAdminForm(!showAdminForm)}
                  className="bg-orange-600 hover:bg-orange-700"
                >
                  <UserPlus className="h-4 w-4 mr-2" />
                  {showAdminForm ? "Cancel" : "Add Admin"}
                </Button>
              )}
            </div>

            {/* Add Admin Form */}
            {showAdminForm && currentAdmin?.role === "super-admin" && (
              <Card className="mb-8 border-0 shadow-lg">
                <CardHeader>
                  <CardTitle className="flex items-center space-x-2">
                    <UserPlus className="h-5 w-5" />
                    <span>Create New Admin</span>
                  </CardTitle>
                  <CardDescription>
                    Add a new admin to manage the job board
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <form onSubmit={handleAdminSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="adminName">Full Name</Label>
                        <Input
                          id="adminName"
                          value={adminFormData.name}
                          onChange={(e) =>
                            setAdminFormData({
                              ...adminFormData,
                              name: e.target.value,
                            })
                          }
                          placeholder="e.g. John Doe"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="adminEmail">Email</Label>
                        <Input
                          id="adminEmail"
                          type="email"
                          value={adminFormData.email}
                          onChange={(e) =>
                            setAdminFormData({
                              ...adminFormData,
                              email: e.target.value,
                            })
                          }
                          placeholder="e.g. john@company.com"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="adminPassword">Password</Label>
                        <Input
                          id="adminPassword"
                          type="password"
                          value={adminFormData.password}
                          onChange={(e) =>
                            setAdminFormData({
                              ...adminFormData,
                              password: e.target.value,
                            })
                          }
                          placeholder="Minimum 6 characters"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="adminRole">Role</Label>
                        <Select
                          value={adminFormData.role}
                          onValueChange={(value) =>
                            setAdminFormData({ ...adminFormData, role: value })
                          }
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Select role" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="admin">Admin</SelectItem>
                            <SelectItem value="super-admin">
                              Super Admin
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>

                    <Button
                      type="submit"
                      className="w-full bg-orange-600 hover:bg-orange-700"
                    >
                      Create Admin
                    </Button>
                  </form>
                </CardContent>
              </Card>
            )}

            {/* Admins List */}
            {admins.length === 0 ? (
              <Card className="text-center py-12">
                <CardContent>
                  <Shield className="h-16 w-16 text-slate-400 mx-auto mb-4" />
                  <p className="text-slate-600 text-lg mb-2">No admins found</p>
                  <p className="text-slate-500 mb-6">
                    Create your first admin to get started
                  </p>
                  {currentAdmin?.role === "super-admin" && (
                    <Button onClick={() => setShowAdminForm(true)}>
                      <UserPlus className="h-4 w-4 mr-2" />
                      Create First Admin
                    </Button>
                  )}
                </CardContent>
              </Card>
            ) : (
              <div className="space-y-4">
                {admins.map((admin) => (
                  <Card
                    key={admin._id}
                    className="hover:shadow-md transition-shadow border-0 shadow-sm"
                  >
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-4">
                          <div className="p-3 bg-orange-100 rounded-full">
                            <Shield className="h-6 w-6 text-orange-600" />
                          </div>
                          <div>
                            <h3 className="text-lg font-semibold text-slate-800">
                              {admin.name}
                            </h3>
                            <p className="text-slate-600">{admin.email}</p>
                            <div className="flex items-center space-x-4 mt-2">
                              <Badge
                                className={
                                  admin.role === "super-admin"
                                    ? "bg-red-100 text-red-800"
                                    : "bg-blue-100 text-blue-800"
                                }
                              >
                                {admin.role === "super-admin"
                                  ? "Super Admin"
                                  : "Admin"}
                              </Badge>
                              <Badge
                                className={
                                  admin.isActive
                                    ? "bg-green-100 text-green-800"
                                    : "bg-gray-100 text-gray-800"
                                }
                              >
                                {admin.isActive ? "Active" : "Inactive"}
                              </Badge>
                            </div>
                          </div>
                        </div>
                        <div className="text-right text-sm text-slate-500">
                          <p>
                            Created:{" "}
                            {new Date(admin.createdAt).toLocaleDateString()}
                          </p>
                          {admin.lastLogin && (
                            <p>
                              Last login:{" "}
                              {new Date(admin.lastLogin).toLocaleDateString()}
                            </p>
                          )}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            )}
          </TabsContent>
        </Tabs>
      </div>

      {/* Job Details Dialog */}
      <Dialog open={!!selectedJob} onOpenChange={() => setSelectedJob(null)}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center space-x-2">
              <Briefcase className="h-5 w-5" />
              <span>Job Details: {selectedJob?.jobTitle}</span>
            </DialogTitle>
          </DialogHeader>

          {selectedJob && (
            <div className="space-y-6">
              {/* Job Information */}
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold text-lg">
                      {selectedJob.jobTitle}
                    </h3>
                    <div className="flex items-center space-x-4 text-sm text-gray-500">
                      <span className="flex items-center">
                        <Building className="h-4 w-4 mr-1" />
                        {selectedJob.companyName}
                      </span>
                      <span className="flex items-center">
                        <MapPin className="h-4 w-4 mr-1" />
                        {selectedJob.location}
                      </span>
                      <Badge
                        variant="secondary"
                        className={getTypeColor(selectedJob.roleType)}
                      >
                        {mapRoleTypeToText(selectedJob.roleType)}
                      </Badge>
                    </div>
                  </div>
                  <div className="text-right">
                    {/* <Badge
                      variant={selectedJob.isActive ? "default" : "secondary"}
                    >
                      {selectedJob.isActive ? "Active" : "Hidden"}
                    </Badge> */}
                    <p className="text-sm text-gray-500 mt-1">
                      Posted:{" "}
                      {new Date(selectedJob.createdOn).toLocaleDateString()}
                    </p>
                  </div>
                </div>

                {/* <div className="flex items-center space-x-4 text-sm text-gray-500">
                  <span className="flex items-center">
                    <DollarSign className="h-4 w-4 mr-1" />
                    Salary Range: {formatCurrency(
                      selectedJob.salary.min
                    )} - {formatCurrency(selectedJob.salary.max)}
                  </span>
                </div> */}

                <div>
                  <h4 className="font-semibold mb-2">Description</h4>
                  <div
                    className="prose max-w-none"
                    dangerouslySetInnerHTML={{
                      __html: selectedJob.description,
                    }}
                  />
                </div>

                {/* <div>
                  <h4 className="font-semibold mb-2">Requirements</h4>
                  <div
                    className="prose max-w-none"
                    dangerouslySetInnerHTML={{
                      __html: selectedJob.requirements,
                    }}
                  />
                </div> */}
              </div>

              {/* Applications Section */}
              <div>
                <h4 className="font-semibold mb-4">
                  Applications ({jobApplications.length})
                </h4>
                {jobApplications.length === 0 ? (
                  <p className="text-gray-500">
                    No applications yet for this position.
                  </p>
                ) : (
                  <div className="space-y-4">
                    {jobApplications.map((app) => (
                      <Card key={app.id} className="border-0 shadow-sm">
                        <CardContent className="p-4">
                          <div className="flex items-center justify-between">
                        <div>
                          <h5 className="font-semibold">
                            Student ID: {app.studentId || "N/A"}
                          </h5>
                          <p className="text-sm text-gray-500">
                            Resume: {app.resume ? "✅" : "❌"} | 
                            Cover Letter: {app.coverLetter ? "✅" : "❌"} | 
                            Video Pitch: {app.videoPitch ? "✅" : "❌"}
                          </p>
                          {app.jobResponse && (
                            <p className="text-sm text-gray-500">
                              Response: {app.jobResponse.responseMessage || "None"} | 
                              Offer Letter: {app.jobResponse.offerLetter ? "✅" : "❌"}
                            </p>
                          )}
                        </div>
                        <div className="text-right">
                          <Badge className={getStatusColor(app.status)}>
                            {getApplicationStatusText(app.status)}
                          </Badge>
                          {app.jobResponse && (
                            <Badge className={app.jobResponse.offerStatus === 1 ? "bg-yellow-100 text-yellow-800" : 
                                                   app.jobResponse.offerStatus === 2 ? "bg-green-100 text-green-800" :
                                                   app.jobResponse.offerStatus === 3 ? "bg-red-100 text-red-800" :
                                                   "bg-orange-100 text-orange-800"}>
                              Offer: {app.jobResponse.offerStatus === 1 ? "Pending" : 
                                      app.jobResponse.offerStatus === 2 ? "Accepted" :
                                      app.jobResponse.offerStatus === 3 ? "Rejected" : "Question"}
                            </Badge>
                          )}
                          <p className="text-xs text-gray-500 mt-1">
                            Applied:{" "}
                            {new Date(app.createdOn).toLocaleDateString()}
                          </p>
                        </div>
                          </div>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Confirmation Dialog */}
      <AlertDialog
        open={jobToToggle !== null}
        onOpenChange={(open: any) => !open && setJobToToggle(null)}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              {jobToToggle?.isActive ? "Activate" : "Deactivate"} Job
            </AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to{" "}
              {jobToToggle?.isActive ? "activate" : "deactivate"} the job
              posting "{jobToToggle?.title}"?
              {jobToToggle?.isActive
                ? " This will make it visible to all users."
                : " This will hide it from all users."}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={() =>
                jobToToggle &&
                handleJobStatusChange(jobToToggle.id, jobToToggle.isActive)
              }
            >
              {jobToToggle?.isActive ? "Activate" : "Deactivate"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
